export const getItemsNumber = (activePendantProductVariantIds: string[]) => { 
  return activePendantProductVariantIds.length + 1 
}
